import { createActions } from "reduxsauce";

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
    industriesRequest: [],
    createIndustryRequest: ['industry'],
    updateIndustryRequest: ['id', 'industry'],

    industriesSuccess: ["industries"],
    createIndustrySuccess: ["industry"],
    updateIndustrySuccess: ["editedIndustry"],

    industriesFailure: ["error"],
    createIndustryFailure: ["error"],
    updateIndustryFailure: ["error"],
})

export const IndustriesTypes = Types;
export default Creators
